import { useMenuNavigation } from '../../hooks/menu/useMenuNavigation';
import { useControlsStore } from '../../store/controlsSlice';
import { INPUT_PRESETS, InputPresetId } from '../../data/controls.config';
import { NineSliceFrame } from './NineSliceFrame';
import { KeyDisplay } from './KeyDisplay';
import './InputPresetPrompt.scss';

const PRESET_ORDER: InputPresetId[] = ['gamepad', 'keyboard', 'keyboard-mouse'];

export const InputPresetPrompt = () => {
  const applyPreset = useControlsStore((s) => s.applyPreset);
  const { containerRef } = useMenuNavigation({
    onConfirm: (id) => {
      applyPreset(id as InputPresetId);
    },
  });

  return (
    <div className="input-preset-overlay">
      <NineSliceFrame className="input-preset-frame">
        <h1 className="input-preset-title">Choisis tes contrôles</h1>
        <div className="input-preset-list" ref={containerRef}>
          {PRESET_ORDER.map((id, i) => (
            <div
              key={id}
              className="input-preset-card"
              data-nav-row={i}
              data-nav-col={0}
              data-nav-id={id}
            >
              <span className="input-preset-card-label">
                {INPUT_PRESETS[id].label}
              </span>
              <span className="input-preset-card-desc">
                {INPUT_PRESETS[id].description}
              </span>
            </div>
          ))}
        </div>
        <div className="input-preset-hint">
          <KeyDisplay context="interface" action="CONFIRM" size="sm" /> choisir
          · modifiable dans Options
        </div>
      </NineSliceFrame>
    </div>
  );
};
